import { Status as RecommendationStatus } from '@wix/ambassador-ai-scheduling-assistant-v1-recommendation/types';
import { validateProps } from '../../utils';
import { isValidBase } from '../BaseEntity';
export { RecommendationStatus };
export const isValidRecommendation = maybeRecommendation => {
  return isValidBase(maybeRecommendation) && validateProps(maybeRecommendation, ['title']);
};
//# sourceMappingURL=Recommendation.js.map